import React, { useEffect, useRef, useState } from "react";

export enum DISPLAY_OPTIONS {
  OPTION_A,
  OPTION_B
}

export interface SwitchButtonProps {
  optionA: string,
  optionB: string,
  onOptionChange: (option: DISPLAY_OPTIONS) => void,
}

/**
 * A swtich button that alternates values between (optionA) and (optionB).
 */
const SwitchButton: React.FC<SwitchButtonProps> = (props: SwitchButtonProps) => {

  const refDivA = useRef<HTMLDivElement>(null);
  const [widthA, setWidthA] = useState(0);
  const [selectedOption, setSelectedOption] = useState(DISPLAY_OPTIONS.OPTION_A);

  // set width A once after page is loaded
  useEffect(() => {
    setWidthA(refDivA.current?.offsetWidth ?? 0);
  }, [refDivA])

  const flipHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (selectedOption === DISPLAY_OPTIONS.OPTION_B) {
      setSelectedOption(DISPLAY_OPTIONS.OPTION_A);
      props.onOptionChange(DISPLAY_OPTIONS.OPTION_A);
    } else {
      setSelectedOption(DISPLAY_OPTIONS.OPTION_B);
      props.onOptionChange(DISPLAY_OPTIONS.OPTION_B);
    }
  }

  return (
    <div>
      <div className="group relative text-xs lg:text-sm font-semibold select-none rounded-full items-center [perspective:200px] text-nowrap" data-selected={selectedOption === DISPLAY_OPTIONS.OPTION_A ? "front" : "back"} onClick={flipHandler}>
        <div title={`Escolha ver em ${props.optionA} ou ${props.optionB}`}
          className={`flex w-fit h-fit items-center cursor-pointer rounded-full text-neutral-300 hover:text-slate-50 bg-neutral-200/20 hover:opacity-85 shadow-md shadow-slate-900/80
            *:h-full *:w-fit *:py-1 *:px-3 lg:*:min-w-8 *:items-center *:justify-center *:rounded-full *:border
        `} style={{ "--w-a": `${widthA}px` } as React.CSSProperties}>
          <div className={`absolute z-10 text-white/0 left-0 group-data-[selected=back]:translate-x-[calc(var(--w-a))] border-neutral-200/20 bg-slate-900 h-full transition-all ease-in-out duration-300`}>
            <p className={`${selectedOption === DISPLAY_OPTIONS.OPTION_A ? "" : "hidden"}`}>{props.optionA}</p>
            <p className={`${selectedOption === DISPLAY_OPTIONS.OPTION_A ? "hidden" : ""}`}>{props.optionB}</p>
          </div>
          <div ref={refDivA} className="flex z-20 left-0 border-white/0 group-data-[selected=back]:text-slate-900">
            <p>{props.optionA}</p>
          </div>
          <div className="flex z-20 right-0 border-white/0 group-data-[selected=front]:text-slate-900">
            <p>{props.optionB}</p>
          </div>
        </div >
      </div>
    </div>
  );
}

export default SwitchButton;